import React from 'react';
import { observer, inject } from 'mobx-react';
import CollectionManager from '../common/CollectionManager';
import Form from './MaterialForm';
import Model from '../../models/Material';

export default inject('store')(observer(props => {
  const filterOptions = [
    { key: 'all', value: '', text: 'All'},
    { key: 'each', value: 'each', text: 'each'},
    { key: 'metre', value: 'metre', text: 'metre'},
    { key: 'sheet', value: 'sheet', text: 'sheet'},
  ]
  return <CollectionManager
    collectionName='materials'
    FormComponent={Form}
    getItems={props.store.getMaterials}
    getNewItem={() => Model.create()}
    searchPlaceholder='Search materials...'
    addButtonText='Add Material'
    filterOptions={filterOptions}
    {...props}
  />
}))


// WEBPACK FOOTER //
// ./src/components/materials/Materials.js